var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "rbCheckboxesContainer" },
    _vm._l(_vm.options, function (option) {
      return _c(
        "label",
        { key: option.value, staticClass: "rbCheckbox rbCheckboxesCheckbox" },
        [
          _c("input", {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.vModel,
                expression: "vModel",
              },
            ],
            staticClass: "rbCheckboxInput",
            attrs: { id: _vm.name, type: "checkbox" },
            domProps: {
              value: option.value,
              checked: Array.isArray(_vm.vModel)
                ? _vm._i(_vm.vModel, option.value) > -1
                : _vm.vModel,
            },
            on: {
              change: [
                function ($event) {
                  var $$a = _vm.vModel,
                    $$el = $event.target,
                    $$c = $$el.checked ? true : false
                  if (Array.isArray($$a)) {
                    var $$v = option.value,
                      $$i = _vm._i($$a, $$v)
                    if ($$el.checked) {
                      $$i < 0 && (_vm.vModel = $$a.concat([$$v]))
                    } else {
                      $$i > -1 &&
                        (_vm.vModel = $$a
                          .slice(0, $$i)
                          .concat($$a.slice($$i + 1)))
                    }
                  } else {
                    _vm.vModel = $$c
                  }
                },
                function ($event) {
                  return _vm.changeHandler()
                },
              ],
            },
          }),
          _c(
            "span",
            {
              staticClass: "rbCheckboxLabel rbCheckboxesLabel",
              class: { checked: _vm.isSelected(option.value) },
            },
            [_vm._v(" " + _vm._s(option.label) + " ")]
          ),
        ]
      )
    }),
    0
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }